module.exports = __webpack_public_path__ + "img/iconnlp.1bce0c7a.png";